"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Thumbnail_1 = __importDefault(require("./Thumbnail")); // @ts-ignore


var react_window_1 = __importDefault(require("@tleef/react-window"));

var EventEmitter = require("eventemitter3");

var Grid =
/** @class */
function (_super) {
  __extends(Grid, _super);

  function Grid(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      galleryWidth: 0
    };
    _this._gallery = react_1.default.createRef();
    _this._emitter = new EventEmitter();
    return _this;
  }

  Grid.prototype.componentDidMount = function () {
    this.onResizeGallery();
    this.loadImages();
  };

  Grid.prototype.onResizeGallery = function () {
    if (!this._gallery.current) return;
    this.setState({
      galleryWidth: Math.floor(this._gallery.current.clientWidth)
    });
  };

  Grid.prototype.loadImages = function () {
    this._emitter.emit("thumbnail:check");
  };

  Grid.prototype.buildImageRow = function (thumbnails, galleryWidth) {
    var row = [];
    var len = 0;
    var imgMargin = 2 * this.props.margin;

    while (thumbnails.length > 0 && len < galleryWidth) {
      var thumb = thumbnails.shift();

      if (!thumb) {
        continue;
      }

      row.push(thumb);
      len += thumb.width + imgMargin;
    }

    var delta = len - galleryWidth;

    if (row.length > 0 && delta > 0) {
      var cutoff = calculateCutOff(len, delta, row);

      for (var i in row) {
        var pixelsToRemove = cutoff[i];
        var thumb = row[i];
        thumb.marginLeft = -Math.abs(Math.floor(pixelsToRemove / 2));
        thumb.vWidth = thumb.width - pixelsToRemove;
      }
    }

    return row;
  };

  Grid.prototype.createThumbnail = function (image) {
    var width = Math.floor(this.props.rowHeight * (image.width / image.height));
    return {
      src: image.src,
      width: width,
      height: this.props.rowHeight,
      marginLeft: 0,
      vWidth: width,
      orientation: image.orientation,
      alt: image.alt
    };
  };

  Grid.prototype.calculateThumnails = function (images, galleryWidth) {
    var _this = this;

    if (images === void 0) {
      images = this.props.images;
    }

    if (galleryWidth === void 0) {
      galleryWidth = this.state.galleryWidth;
    }

    if (!images) return [];
    if (galleryWidth === 0) return [];
    var thumbnails = images.map(function (img) {
      return _this.createThumbnail(img);
    });
    var thumbs = [];
    var rows = [];

    while (thumbnails.length > 0) {
      rows.push(this.buildImageRow(thumbnails, galleryWidth));
    }

    for (var r = 0; r < rows.length; r++) {
      var row = rows[r];

      for (var i = 0; i < row.length; i++) {
        var thumb = row[i];

        if (this.props.maxRows) {
          if (r < this.props.maxRows) {
            thumbs.push(thumb);
          }
        } else {
          thumbs.push(thumb);
        }
      }
    }

    return thumbs;
  };

  Grid.prototype.render = function () {
    var _this = this;

    var thumbnails = this.calculateThumnails();
    var images = thumbnails.map(function (thumbnail, idx) {
      return react_1.default.createElement(Thumbnail_1.default, __assign({
        key: "Thumbnail-" + idx + "-" + thumbnail.src,
        index: idx,
        margin: _this.props.margin
      }, thumbnail, {
        onClick: _this.props.onClickThumbnail || null,
        tileViewportStyle: _this.props.tileViewportStyle,
        thumbnailStyle: _this.props.thumbnailStyle,
        events: _this._emitter
      }));
    });
    return react_1.default.createElement(react_window_1.default, {
      onResize: debounce(function () {
        return _this.loadImages();
      }, 30, false),
      onScroll: debounce(function () {
        return _this.loadImages();
      }, 30, false)
    }, react_1.default.createElement("div", {
      ref: this._gallery,
      style: {
        display: "flex",
        flexWrap: "wrap"
      }
    }, react_1.default.createElement("iframe", {
      style: {
        height: 0,
        margin: 0,
        padding: 0,
        borderWidth: 0,
        overflow: "hidden",
        backgroundColor: "transparent",
        width: "100%"
      },
      ref: function ref(c) {
        return c && c.contentWindow && c.contentWindow.addEventListener("resize", debounce(function () {
          return _this.onResizeGallery();
        }, 30, false));
      }
    }), images));
  };

  Grid.defaultProps = {
    rowHeight: 180,
    margin: 2
  };
  return Grid;
}(react_1.default.PureComponent);

function calculateCutOff(len, delta, thumbnails) {
  var cutoff = [];
  var cutsum = 0;

  for (var i in thumbnails) {
    var thumb = thumbnails[i];
    var fractOfLen = thumb.width / len;
    cutoff[i] = Math.floor(fractOfLen * delta);
    cutsum += cutoff[i];
  }

  var stillToCutOff = delta - cutsum;

  while (stillToCutOff > 0) {
    for (var i in cutoff) {
      cutoff[i]++;
      stillToCutOff--;
      if (stillToCutOff < 0) break;
    }
  }

  return cutoff;
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;

    var later = function later() {
      timeout = undefined;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

exports.default = Grid;